export const FAQ_BLOCK_s4 = {
  "blockType": "FAQ",
  "blockDesign": "FAQDesign1",
  "editFormName": "FAQ_FORM_1",
  "styleProps": {
    "background-color": "#ffffff",
    "background-image": "url('')",
    "padding": "120px 20px 120px 20px"
  },
  "sectionConfigs": {
    "headerTextStyleProps": {
      "font-size": "1.5rem",
      "line-height": "2rem",
      "font-weight": "500",
      "padding": "14px 30px 14px 30px",
      "color": "#55524E"
    },
    "bodyTextStyleProps": {
      "padding": "14px 30px 14px 30px",
      "color": "#98928b",
      "font-size": "1.125rem",
      "line-height": "1.75rem"
    },
    "sectionStyleProps": {
      "backgroundColor": "#f8f8f8",
      "padding": "30px 24px 30px 24px",
      "border-width": "0px",
      "border-radius": "1.5rem",
      "border-color": "#DDDACC",
      "margin": "0px 0px 8px 0px",
      "background-color": "#FAFAFA"
    }
  },
  "headings": [
    {
      "text": "Questions and answers",
      "styleProps": {
        "font-weight": "400",
        "text-align": "center",
        "font-size": "2.25rem",
        "line-height": "2.5rem",
        "padding": "0px 0px 10px 0px",
        "margin": "0px 20px 0px 20px",
        "color": "#232323"
      },
      "alignStyleProps": {
        "text-align": "center"
      }
    },
    {
      "text": "Everything you need to know",
      "styleProps": {
        "text-align": "center",
        "font-size": "2.25rem",
        "line-height": "1",
        "font-weight": "400",
        "padding": "0px 0px 20px 0px",
        "margin": "0px 20px 80px 20px",
        "font-family-cust": "Playfair Display",
        "color": "#808080"
      },
      "alignStyleProps": {
        "text-align": "center"
      }
    }
  ],
  "list": [
    {
      "headerText": "What subscription tiers can I subscribe to with flezr?",
      "bodyText": "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with"
    },
    {
      "headerText": "How much does a subscription to faq cost, and for how long can I subscribe?",
      "bodyText": "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with"
    },
    {
      "headerText": "Can we use the code/art/assets in Flezr Technologies' example projects?",
      "bodyText": "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with"
    }
  ],
  "metaDataId": 1746183644529,
  "afterIndex": 0,
  "blockId": 1746183644529,
  "fonts": {
    "headings": [
      null,
      "Playfair Display"
    ]
  },
  "containerStyleProps": {
    "padding": "0px 20px 0px 20px",
    "max-width": "998px"
  }
}